import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/auth/forgot-password/')({
  component: ForgotPasswordPage,
});

function ForgotPasswordPage() {
  return <div>Hello "/forgot-password/"!</div>;
}
